import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FeaturesState {
  show_completed_payments: boolean;
  enable_wallet: boolean;
  enable_advance_payment: boolean;
  enable_partial_payment: boolean;
  show_stock_alerts: boolean;
  enable_correspondence: boolean;
  enable_contract_download: boolean;
  isLoaded: boolean;
}

const initialState: FeaturesState = {
  show_completed_payments: true,
  enable_wallet: false,
  enable_advance_payment: true,
  enable_partial_payment: true,
  show_stock_alerts: true,
  enable_correspondence: true,
  enable_contract_download: true,
  isLoaded: false,
};

const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    setFeatures: (state, action: PayloadAction<Partial<FeaturesState>>) => {
      return { ...state, ...action.payload, isLoaded: true };
    },
    setFeaturesLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
  },
});

export const { setFeatures, setFeaturesLoaded } = featuresSlice.actions;
export default featuresSlice.reducer;

